import HttpClient from "@services/HttpClient";

export const CountryService = {
    getCountries: async (params) => {
        const res = await new HttpClient().post(
            "/countries/list-option",
            params
        );
        if (res.status === 200) {
            return res.data.data;
        }
        return [];
    },
};
